import React from 'react';
import {Table, Tag} from 'antd';
import {intToHexVersion} from '../utils'
import SystemHubButtonUpdate from './SystemHubButtonUpdate';
import SystemHubButtonDelete from './SystemHubButtonDelete';
import SystemHubButtonUploadFirmware from './SystemHubButtonUploadFirmware';
import SystemHubButtonUpgrade from './SystemHubButtonUpgrade';
import {HUB_STATE_RUN, HUB_STATE_STOP, HUB_STATE_IN_ACTIVE} from '../constants/defaultValues'

class SystemHubTable extends React.Component {
  render() {
    const {
      hubs,
      stations,
      groups,
      system,
      token,
      fetching,
      isMobile,
      onCreate,
      onUpdate,
      onDelete,
      onUpload,
      onUpgrade
    } = this.props
    const columns = [
      {
        title: 'Tên',
        dataIndex: 'Name',
        key: 'name'
      }, {
        title: 'Port',
        dataIndex: 'HubAddress',
        key: 'address'
      }, {
        title: 'Version',
        dataIndex: 'FirmwareVersion',
        key: 'version',
        render: (text, hub) => (intToHexVersion(hub.FirmwareVersion))
      }, {
        title: 'Kích hoạt download',
        dataIndex: 'FirmwareDownloadEnable',
        key: 'download',
        render: (text, hub) => (
          hub.FirmwareDownloadEnable
          ? <Tag color="green">loading</Tag>
          : <Tag color="red">stop</Tag>)
      }, {
        title: 'Clients',
        dataIndex: 'NumClients',
        key: 'clients'
      }, {
        title: 'Trạng thái',
        dataIndex: 'State',
        key: 'state',
        render: (text, hub) => (
          hub.State === HUB_STATE_RUN
          ? <Tag color="green">running</Tag>
          : hub.State === HUB_STATE_IN_ACTIVE
            ? <Tag color="gray">inactive</Tag>
            : <Tag color="red">stop</Tag>)
      }, {
        title: '...',
        key: 'action',
        render: (text, hub) => (<span>
          <SystemHubButtonUpdate hub={hub} onUpdate={onUpdate}/>
          <span className="ant-divider"/>
          <SystemHubButtonDelete hub={hub} onDelete={onDelete}/>
          <span className="ant-divider"/>
          <SystemHubButtonUploadFirmware hub={hub} system={system} token={token} onUpload={onUpload}/>
          <span className="ant-divider"/>
          <SystemHubButtonUpgrade hub={hub} stations={stations} groups={groups} isMobile={isMobile} onUpload={onUpload} onUpgrade={onUpgrade}/>
        </span>)
      }
    ];
    return <Table columns={columns} dataSource={hubs} rowKey={hub => hub.ID} loading={fetching}/>
  }
}
export default SystemHubTable



// WEBPACK FOOTER //
// ./src/components/SystemHubTable.js